import { render, staticRenderFns } from "./VendorChargesTable.vue?vue&type=template&id=38a7373f&scoped=true"
import script from "./VendorChargesTable.vue?vue&type=script&lang=js"
export * from "./VendorChargesTable.vue?vue&type=script&lang=js"
import style0 from "./VendorChargesTable.vue?vue&type=style&index=0&id=38a7373f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a7373f",
  null
  
)

export default component.exports